import React from 'react';
import { Alert } from '@mui/material';

export type GlLastYearBsStatus = {
    netAssets: number;
    capitalReserves: number;
    equal: boolean;
    zero: boolean;
    lastYearNetAssets?: number;
    lastYearCapitalReserves?: number;
    equalLastYear?: boolean;
    zeroLastYear?: boolean;
};

/** Last Year 录入：净资产负债与资本公积是否平衡。 */
export function GlLastYearBalanceAlert({
    errorMsg,
    status,
}: {
    errorMsg: string | null;
    status: GlLastYearBsStatus | null;
}) {
    const hasLy = status?.equalLastYear != null;
    const lyEqual = status?.equalLastYear === true;
    const lyZero = status?.zeroLastYear === true;
    const showError = !!errorMsg && hasLy && !lyEqual && !lyZero;
    const showOk = hasLy && lyEqual && !lyZero;

    if (showError) {
        return (
            <Alert severity="warning" sx={{ mb: 1, whiteSpace: 'pre-line' }}>
                {errorMsg}
            </Alert>
        );
    }
    if (showOk) {
        const net = status?.lastYearNetAssets ?? 0;
        const cap = status?.lastYearCapitalReserves ?? 0;
        const fmt = (v: number) => v.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return (
            <Alert severity="success" sx={{ mb: 1 }}>
                Last Year balanced: Net Assets {fmt(net)} = Capital and Reserves {fmt(cap)}.
            </Alert>
        );
    }
    return null;
}
